import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import Store from "./Store";
import i18n from "./i18next";
import { checkForNewVersion } from "./versionCheck";
// import 'core-js/fn/number/is-nan';
import "core-js";
// import 'core-js/es/array';
import "babel-polyfill";

import "raf/polyfill";
import { Provider } from "react-redux";

// Build stamp so QA can verify the deployed build (DevTools console: APP_BUILD)
window.APP_BUILD = {
  version: process.env.REACT_APP_BUILD_VERSION,
  time: process.env.REACT_APP_BUILD_TIME,
};
console.info(
  `Build version: ${window.APP_BUILD.version} | Built at: ${window.APP_BUILD.time}`,
);
// Render only after confirming this is the latest build. Until then the static
// loader inside #root (public/index.html) stays on screen.
checkForNewVersion().then((reloading) => {
  if (reloading) return;
  ReactDOM.render(
    <Provider store={Store}>
      <App />
    </Provider>,
    document.getElementById("root"),
  );
});

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
